import { filterCsvDataByVisibleColumns } from '@/lib/exportCsv';

export function getStaticDataLabelExportKeysByColumn(t: (key: string) => string): Record<string, readonly string[]> {
  return {
    sno: ['SN'],
    staticDataLabel: [t('logsManagement.staticDataTypeLabel.page.table.staticDataLabel')],
    staticDataDescription: [t('logsManagement.staticDataTypeLabel.page.table.staticDataDescription')],
  };
}

export function keepVisibleDataLabelExportColumns(
  rows: Array<Record<string, unknown>>,
  visibleColumnIds: readonly string[],
  exportKeysByColumn: Record<string, readonly string[]> = getStaticDataLabelExportKeysByColumn((key) => key),
) {
  return filterCsvDataByVisibleColumns(rows, visibleColumnIds, exportKeysByColumn);
}
